var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var callRequest = require('../../../../../include/_js/callback/callback-request');

        var _require = require('../../../../../include/_js/callback/working-time'),
            isWorkingTimeNow = _require.isWorkingTimeNow;

        var win = window;

        /**
         * @param {jQuery} $form
         * @param {boolean} show
         */
        function toggleFormStateResult($form, show) {
            $form.toggleClass('state-result', show);
        }

        /**
         * Плавающая форма справа снизу (появляющаяся при скроле)
         */

        var CallbackEmergeForm = function () {
            function CallbackEmergeForm() {
                _classCallCheck(this, CallbackEmergeForm);
            }

            _createClass(CallbackEmergeForm, null, [{
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    // Переключение режима отображения
                    $('#show-emerge-callback').one('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation(); // disable '.callback-form-submit' event listener callback
                        $('.emerge-callback-form').addClass('active');
                        // Меняем лейбл кнопки и поведение при нажатии за счет класса
                        $(this).html('Отправить').addClass('callback-form-submit');
                    });
                }
            }, {
                key: "clearValues",
                value: function clearValues() {
                    var $form = $('.emerge-callback-form');
                    $form.find('.callback-widget-name').val('');
                    $form.find('.callback-widget-phone').val('');
                }
            }]);

            return CallbackEmergeForm;
        }();

        /**
         * Основная форма popup
         * Реализуется в 2 шага. На 2ом шаге доступен выбор времени звонка
         */


        var CallbackMainForm = function () {
            function CallbackMainForm() {
                _classCallCheck(this, CallbackMainForm);
            }

            _createClass(CallbackMainForm, null, [{
                key: "isMainPopupForm",
                value: function isMainPopupForm($form) {
                    return $form.hasClass('callback-form-popup');
                }
            }, {
                key: "isChangeCallTimeForm",
                value: function isChangeCallTimeForm(params) {
                    return params.isChooseCallTime === 1;
                }

                /**
                 * Показать форму колбека в модальном окне, форма в 2 шага, выбором времени звонка
                 * @param {CallbackParams|null} params
                 * @param {boolean} runSubmit
                 */

            }, {
                key: "open",
                value: function open() {
                    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var runSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var $formClone = $('#callback-form-popup .callback-form').clone();
                    window.applyPhoneMask($('.phone-mask', $formClone));
                    if (params) {
                        // Прокидываем параметры с формы на странице
                        $formClone.find('.callback-widget-city_id').val(params.cityId);
                        $formClone.find('.callback-widget-phone').val(params.phone);
                    }

                    // toggleFormStateResult($formClone, false);
                    CallbackMainForm.toggleChangeCallTimeState($formClone, null);
                    win.bs3popup({
                        content: $formClone,
                        width: 530,
                        setLock: true,
                        onAfterShow: function onAfterShow() {
                            if (runSubmit) {
                                $formClone.find('.callback-form-submit').trigger('click');
                            }
                        }
                    });
                }

                /**
                 * @param {jQuery} $form
                 * @param {CallbackCreateResponse} response
                 */

            }, {
                key: "showChangeCallTimeForm",
                value: function showChangeCallTimeForm($form, response) {
                    CallbackMainForm.toggleChangeCallTimeState($form, response);
                }

                /**
                 * @private
                 * Устанавливаем состояние формы обратного звонка
                 * Создание|Изменение времени звонка
                 * @param {jQuery} $form
                 * @param {CallbackCreateResponse|null} response
                 */

            }, {
                key: "toggleChangeCallTimeState",
                value: function toggleChangeCallTimeState($form) {
                    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var enabled = response !== null;
                    var request = response ? response.request : null;

                    $form.find('.callback-on-working').toggleClass('hidden', enabled);
                    $form.find('.callback-night-time').toggleClass('hidden', !enabled);
                    // В режиме изменения времени номер менять нельзя
                    $form.find('.callback-widget-phone').toggleClass('hidden', enabled);
                    // values
                    $form.find('.callback-widget-is-choose-time').val(request ? 1 : 0);
                    $form.find('.callback-widget-delayed-date').val(request ? request.callDate : '');
                    $form.find('.callback-widget-delayed-time').val(request ? request.callTime : '');
                    $form.find('.callback-widget-request-id').val(request ? request.id : '');

                    var $submitButton = $form.find('.callback-form-submit');
                    var btnLabel = enabled ? $submitButton.data('change-label') : $submitButton.data('create-label');
                    $submitButton.text(btnLabel);

                    if (enabled) {
                        var timeOptions = '';
                        for (var time in response.callTimes) {
                            if (response.callTimes[time]) {
                                var activeClass = time === response.selectedCallTime ? 'active' : '';
                                timeOptions += "<button type=\"button\" class=\"" + activeClass + "\" data-time=\"" + time + "\">" + time + "</button>";
                            }
                        }
                        $form.find('.callback-choose-time').html(timeOptions);
                        $form.find('.callback-night-time__value').html(request.callDateTimeDescription);
                    }
                }
            }]);

            return CallbackMainForm;
        }();

        /**
         * - Сообщения на форме: загрузка|успешно|ошибка
         * - Частичное управление состоянием формы:
         *      скрытие части контролов в зависимости от типа сообщения
         */


        var CallbackFormMessage = function () {
            function CallbackFormMessage() {
                _classCallCheck(this, CallbackFormMessage);
            }

            _createClass(CallbackFormMessage, null, [{
                key: "getResponseMessageHtml",
                value: function getResponseMessageHtml(title, hint) {
                    return "<div class=\"block-title\">" + title.toUpperCase() + "!</div>\n            <div class=\"block-hint\">" + hint + "</div>";
                }
            }, {
                key: "showLoading",
                value: function showLoading($form) {
                    var $resultField = $form.find('.callback-result-wrap');
                    $resultField.html(win.getMessageTemplate('loading')).removeClass('hidden');

                    // показываем контейнер результата заранее
                    // т.к. сообщение loading показывается там же, где и результат,
                    toggleFormStateResult($form, true);
                }

                /**
                 * @param {jQuery} $form
                 * @param {string} message
                 */

            }, {
                key: "showFinalResultMessage",
                value: function showFinalResultMessage($form, message) {
                    // Показываем экран с сообщением
                    $form.find('.callback-result-wrap').html(message);
                    toggleFormStateResult($form, true);
                }

                /**
                 * @param {{success: boolean, title: string, message: string}} response
                 */

            }, {
                key: "createFinalMessage",
                value: function createFinalMessage(response) {
                    var message = void 0;
                    if (response.success) {
                        // Успешно. Дозвон сразу. Устанавливаем финальное состояние
                        message = CallbackFormMessage.getResponseMessageHtml(response.title, response.message);
                    } else {
                        // Ошибка
                        message = win.getMessageTemplate('error', CallbackFormMessage.getResponseMessageHtml(response.title, response.message));
                    }

                    return message;
                }

                /**
                 * Результат запроса на изменение времени
                 * @param $form
                 * @param {CallbackParams} requestParams
                 * @param {{success: boolean, title: string, message: string}} response
                 */

            }, {
                key: "showChangeCallTimeResultMessage",
                value: function showChangeCallTimeResultMessage($form, requestParams, response) {
                    var messageHTML = CallbackFormMessage.createFinalMessage(response);
                    if (response.success) {
                        $('.hidden-on-end', $form).addClass('hidden'); // Скрыть все контролы и т.п.
                    }
                    CallbackFormMessage.showFinalResultMessage($form, messageHTML);
                }

                /**
                 * @param $form
                 * @param {CallbackParams} requestParams
                 * @param {CallbackCreateResponse} response
                 */

            }, {
                key: "showCreateResultMessage",
                value: function showCreateResultMessage($form, requestParams, response) {
                    /** @type {CallbackRequestEntity|null} */
                    var request = response.request;

                    // Значение по умолчанию убирает другие тексты, e.g. лоадер
                    if (response.success && request.allowChangeCallTime) {
                        // У отложенных колбеков можно изменить время звонка.
                        // Показываем форму с возможностью изменить время звонка.
                        CallbackMainForm.showChangeCallTimeForm($form, response);
                        // Скрываем лоадер и т.п. Т.к. лоадер в том же блоке что и результат
                        CallbackFormMessage.showFinalResultMessage($form, '');
                    } else {
                        // Вывод сообщения об ошибке
                        var messageHTML = CallbackFormMessage.createFinalMessage({
                            success: response.success,
                            title: response.title,
                            message: response.message
                        });
                        if (response.success) {
                            $('.hidden-on-end', $form).addClass('hidden'); // Скрыть все контролы и т.п.
                        }
                        CallbackFormMessage.showFinalResultMessage($form, messageHTML);
                    }
                }
            }]);

            return CallbackFormMessage;
        }();

        /**
         * Инициализация всех обработчиков
         * - submit
         * - change time
         * - open on button click
         * - emerge form show on scroll
         * - ...
         */


        var CallbackForm = function () {
            function CallbackForm() {
                _classCallCheck(this, CallbackForm);
            }

            _createClass(CallbackForm, null, [{
                key: "init",
                value: function init() {
                    // Общие обработчики для всех форм
                    CallbackEmergeForm.bindEventListeners();
                    // Обработчики плавающей формы справа снизу (emerge-callback-form)
                    CallbackForm.bindGeneralEventListeners();
                }

                /**
                 * Обработчики, общие для всех форм
                 */

            }, {
                key: "bindGeneralEventListeners",
                value: function bindGeneralEventListeners() {
                    window.openCallbackPopup = CallbackMainForm.open;
                    $('body')
                    // Показать основную форму обратного звонка в модальном окне
                    .on('click', '.open-callback-popup', function () {
                        CallbackMainForm.open();
                        window.tracking.setEvent(window.app.goals.SHOW_NEW_REQUEST_FORM);
                    })
                    // Удаляет alert
                    .on('click', '.alert__close', function () {
                        var $alert = $(this).closest('.alert-message');
                        if ($alert.hasClass('alert-success')) {
                            CallbackEmergeForm.clearValues();
                        }
                        $alert.remove();
                    })
                    // Обработчик submit формы обратного звонка
                    .on('click', '.callback-form-submit', function (e) {
                        e.preventDefault();
                        var $button = $(this);
                        var $form = $button.closest('.callback-form');
                        if (!$form.length) {
                            return;
                        }
                        var submitCallback = function submitCallback(params) {
                            // Валидация формы. Подсвечиваем поля с ошибкой
                            var $phoneContainer = $form.find('.callback-widget-phone').closest('.form-group');
                            if (!params.validate()) {
                                if (params.haveError(params.errorFields.PHONE)) {
                                    $phoneContainer.addClass('has-error').one('keyup', function () {
                                        $(this).removeClass('has-error');
                                    });
                                }
                                return;
                            }

                            if (!CallbackMainForm.isMainPopupForm($form)) {
                                // При submit с любой формы, кроме main.
                                // Открываем основную форму колбека, прокидываем данные и эмулируем submit
                                CallbackMainForm.open(params, true);
                                CallbackEmergeForm.clearValues();
                                return;
                            }

                            CallbackForm.toggleSubmitButton($button, false);
                            CallbackFormMessage.showLoading($form);

                            if (CallbackMainForm.isChangeCallTimeForm(params)) {
                                // Запрос на изменение времени звонка
                                callRequest.changeCallTime(params, function (response) {
                                    CallbackForm.toggleSubmitButton($button, true);
                                    CallbackFormMessage.showChangeCallTimeResultMessage($form, params, response);
                                });
                                return;
                            }

                            // Новый запрос на обратный звонок
                            window.callRequest.create(params, function (response) {
                                CallbackForm.toggleSubmitButton($button, true);
                                CallbackFormMessage.showCreateResultMessage($form, params, response);
                            });
                        };

                        var params = CallbackForm.buildFormParams($form);
                        if (window.app.useGoogleCaptchaForCallback) {
                            window.loadGoogleCaptcha().then(function () {
                                return grecaptcha.execute(window.app.googleCaptchaSiteKey, {
                                    action: 'callback_request'
                                });
                            }).then(function (token) {
                                params.recaptchaToken = token;
                                submitCallback(params);
                            }).catch(function (error) {
                                console.error('Error with reCAPTCHA:', error);
                                CallbackForm.toggleSubmitButton($button, true);
                            });
                        } else {
                            submitCallback(params);
                        }
                    })
                    // Обработчик выбора времени звонка на форме CallbackMainForm
                    .on('click', '.callback-choose-time button', function () {
                        var $button = $(this);
                        var time = $button.data('time');
                        $button.parent().find('.active').removeClass('active');
                        $button.addClass('active');
                        $('.callback-widget-delayed-time').val(time);
                    });
                }

                /**
                 * Собрать значения с формы в класс
                 * @param $form
                 * @return {CallbackParams}
                 */

            }, {
                key: "buildFormParams",
                value: function buildFormParams($form) {
                    var $cityField = $form.find('.callback-widget-city_id');
                    var $phoneField = $form.find('.callback-widget-phone');

                    var params = {
                        cityId: $cityField.val(),
                        phone: $phoneField.val().trim(),
                        isChooseCallTime: 0
                    };

                    var $clientNameField = $form.find('.callback-widget-name');
                    if ($clientNameField.length) {
                        params.clientName = $clientNameField.val();
                    }

                    var isChooseCallTime = parseInt($form.find('.callback-widget-is-choose-time').val(), 10);
                    if (isChooseCallTime) {
                        params.isChooseCallTime = 1;
                        var $date = $form.find('.callback-widget-delayed-date');
                        var $time = $form.find('.callback-widget-delayed-time');
                        var $requestId = $form.find('.callback-widget-request-id');
                        params.callDate = $date.length ? $date.val() : '';
                        params.callTime = $time.length ? $time.val() : '';
                        params.requestId = $requestId.length ? $requestId.val() : '';
                    }

                    return new callRequest.Params(params);
                }
            }, {
                key: "toggleSubmitButton",
                value: function toggleSubmitButton($button, enabled) {
                    $button.prop('disabled', !enabled).toggleClass('disabled', !enabled);
                }
            }]);

            return CallbackForm;
        }();

        CallbackForm.init();
    }, { "../../../../../include/_js/callback/callback-request": 5, "../../../../../include/_js/callback/working-time": 6 }], 2: [function (require, module, exports) {
        var FIELD_PHONE = 'phone';
        var FIELD_DATE_TIME = 'dateTime';

        var _require2 = require('../phone-validator'),
            validatePhone = _require2.validatePhone;

        var win = window;

        var CallbackParams = function () {
            function CallbackParams(params) {
                _classCallCheck(this, CallbackParams);

                this.srcId = win.app.src_id ? win.app.src_id : null;
                this.vUid = win.app.vUid ? win.app.vUid : '';

                this.clientName = params.hasOwnProperty('clientName') ? params.clientName : '';
                this.cityId = parseInt(params.cityId, 10);
                this.phone = params.phone; // Важно сохранить форматирование, для проброса в maskedInput
                this.isChooseCallTime = params.hasOwnProperty('isChooseCallTime') ? parseInt(params.isChooseCallTime, 10) : 0;
                this.recaptchaToken = params.recaptchaToken || null;

                this.callDate = '';
                this.callTime = '';
                if (this.isChooseCallTime) {
                    this.callDate = params.callDate;
                    this.callTime = params.callTime;
                }

                // Только при изменении времени звонка
                this.requestId = 'requestId' in params ? Number(params.requestId) : null;

                /**
                 * Отдельная "цель" на успешный заказ колебка в YM
                 * @type {string}
                 */
                this.ymConversionEvent = '';
                if (params.ymConversionEvent) {
                    this.setYMConversionEvent(params.ymConversionEvent);
                }
                /**
                 * Отдельная цель на успешный заказ колбека в GA
                 * @type {{eventCategory: string, eventAction: string}|null}
                 */
                this.gaConversionEvent = null;
                if (params.hasOwnProperty('gaConversionEventCategory') && params.hasOwnProperty('gaConversionEventAction')) {
                    this.setGAConversionEvent(params.gaConversionEventCategory, params.gaConversionEventAction);
                }

                this.errorList = {};
                this.errorList[FIELD_PHONE] = {
                    error: false,
                    message: ''
                };
                this.errorList[FIELD_DATE_TIME] = {
                    error: false,
                    message: ''
                };
            }

            _createClass(CallbackParams, [{
                key: "setYMConversionEvent",
                value: function setYMConversionEvent(eventKey) {
                    this.ymConversionEvent = eventKey;
                }
            }, {
                key: "setGAConversionEvent",
                value: function setGAConversionEvent(eventCategory, eventAction) {
                    if (!eventCategory || !eventCategory) {
                        return;
                    }
                    this.gaConversionEvent = {
                        category: eventCategory,
                        action: eventAction
                    };
                }
            }, {
                key: "validate",
                value: function validate() {
                    var isValid = true;
                    if (this.isChooseCallTime) {
                        if (this.callDate === '' || this.callTime === '') {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        } else if (parseInt(this.callTime, 10) === -1) {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        }
                    }

                    if (!validatePhone(this.phone)) {
                        isValid = false;
                        this._addError(FIELD_PHONE, 'Проверьте номер телефона');
                    }

                    return isValid;
                }

                /**
                 *
                 * @param formFields - e.g. $form.serializeArray()
                 * @return {CallbackParams}
                 */

            }, {
                key: "haveError",


                /**
                 * @param {string} field
                 * @return {boolean}
                 */
                value: function haveError(field) {
                    return this.errorList[field].error;
                }
            }, {
                key: "_addError",
                value: function _addError(field, message) {
                    if (!this.errorList.hasOwnProperty(field)) {
                        return false;
                    }

                    this.errorList[field].error = true;
                    this.errorList[field].message = message;
                }
            }, {
                key: "errorFields",
                get: function get() {
                    return {
                        PHONE: FIELD_PHONE,
                        DATETIME: FIELD_DATE_TIME
                    };
                }

                /**
                 * Первое сообщение об ошибке
                 * @return {{field: string, message: string}}
                 */

            }, {
                key: "error",
                get: function get() {
                    var data = { field: '', message: '' };
                    if (this.errorList.phone.error) {
                        data.field = FIELD_PHONE;
                        data.message = this.errorList.phone.message;
                    } else if (this.errorList.dateTime.error) {
                        data.field = FIELD_DATE_TIME;
                        data.message = this.errorList.dateTime.message;
                    }

                    return data;
                }
            }], [{
                key: "loadForm",
                value: function loadForm(formFields) {
                    var params = {};
                    for (var i in formFields) {
                        var field = formFields[i];
                        params[field.name] = field.value;
                    }

                    return new CallbackParams(params);
                }
            }]);

            return CallbackParams;
        }();

        module.exports = CallbackParams;
    }, { "../phone-validator": 7 }], 3: [function (require, module, exports) {

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */
        module.exports = function (params, callback) {
            var requestParams = {
                phone: params.phone,
                cityId: params.cityId,
                requestId: params.requestId,
                callDate: params.callDate,
                callTime: params.callTime
            };

            var response = {
                success: false,
                title: 'Ошибка',
                message: ''
            };

            $.post(window.app.urls.changeCallbackCallTime, requestParams, function (responseData) {
                response.success = responseData.success;
                response.callDateTimeDescription = responseData.callDateTimeDescription;
                if (response.success) {
                    response.title = 'Спасибо';
                    response.message = 'Мы перезвоним ' + responseData.callDateTimeDescription;
                } else {
                    response.title = 'Ошибка';
                    response.message = 'Не удалось изменить время звонка. Извините за неудобства';
                }

                callback(response);
            }, 'json');
        };
    }, {}], 4: [function (require, module, exports) {
        var ERROR_NOT_WORKING_TIME = 'not_working_time';
        var ERROR_NON_CORRECT_DATA = 'non_correct_data';
        var ERROR_EXIST = 'callback exist timeout';

        var CallbackRequestEntity = function CallbackRequestEntity(props) {
            _classCallCheck(this, CallbackRequestEntity);

            /** @type number */
            this.id = props.id;
            /** @type string */
            this.callDate = props.callDate;
            /** @type string */
            this.callTime = props.callTime;
            /** @type string */
            this.callDateTimeDescription = props.callDateTimeDescription;
            /** @type {boolean} */
            this.allowChangeCallTime = props.allowChangeCallTime;
        };

        var CallbackCreateResponse = function CallbackCreateResponse() {
            _classCallCheck(this, CallbackCreateResponse);

            this.success = false;
            this.title = '';
            this.message = '';
            /** @type {CallbackRequestEntity|null} */
            this.request = null;
            /** @type {{}|null} */
            this.callTimes = null;
            /** @type {string} */
            this.selectedCallTime = '';
        };

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */


        module.exports = function (params, callback) {
            var response = new CallbackCreateResponse();

            if (!params.validate()) {
                callback(response);
                return;
            }

            var requestParams = {
                srcId: params.srcId,
                vUid: params.vUid,

                cityId: params.cityId,
                phone: params.phone,
                isChooseCallTime: params.isChooseCallTime
            };
            if (requestParams.isChooseCallTime) {
                requestParams.callDate = params.callDate;
                requestParams.callTime = params.callTime;
            }
            if (params.clientName) {
                requestParams.clientName = params.clientName;
            }

            requestParams.recaptchaToken = params.recaptchaToken;

            $.post(window.app.urls.addCallback, requestParams, function (responseData) {
                if (!responseData.success) {
                    response.title = 'Ошибка';
                    // data.allowRepeat = false;
                    switch (responseData.errorType) {
                        case ERROR_NOT_WORKING_TIME:
                            response.message = 'К сожалению, рабочий день окончен';
                            break;
                        case ERROR_NON_CORRECT_DATA:
                            response.message = 'Введены некорректные данные';
                            break;
                        // case ERROR_EXIST:
                        //     title = 'Мы скоро вам перезвоним';
                        //     // data.allowRepeat = false;
                        //     break;
                        default:
                            response.message = 'Извините, произошла ошибка. Попробуй позднее';
                            break;
                    }
                } else {
                    response.success = true;
                    response.title = 'Спасибо';
                    response.request = new CallbackRequestEntity(responseData.request);
                    response.callTimes = responseData.callTimes;
                    response.selectedCallTime = responseData.selectedCallTime;
                    if (requestParams.isChooseCallTime) {
                        response.message = 'Наш менеджер свяжется с вами в указанное время';
                    } else {
                        response.message = 'Наш менеджер свяжется с вами в ближайшее время';
                    }

                    // отмечаем что был заказан коллбек
                    window.tracking.setEvent(window.app.goals.CREATE_NEW_REQUEST);
                    $('body').trigger('callback:success'); // проброс в angular
                    if (params.ymConversionEvent) {
                        window.tracking.setYaEvent(params.ymConversionEvent);
                    }
                    if (params.gaConversionEvent) {
                        var gaEvent = params.gaConversionEvent;
                        window.tracking.setGAEvent(gaEvent.category, gaEvent.action);
                    }
                }

                callback(response);
            }, 'json');
        };
    }, {}], 5: [function (require, module, exports) {
        var CallbackParams = require('./CallbackParams');
        var callRequestCreate = require('./callback-request-create-fn');
        var changeCallTime = require('./callback-request-change-call-time-fn');

        module.exports = {
            Params: CallbackParams,
            create: callRequestCreate,
            changeCallTime: changeCallTime
        };
    }, { "./CallbackParams": 2, "./callback-request-change-call-time-fn": 3, "./callback-request-create-fn": 4 }], 6: [function (require, module, exports) {
        var DEFAULT_WORK_START_HOUR = 10;
        var DEFAULT_WORK_END_HOUR = 19;
        var SATURDAY_WORK_END_HOUR = 15;

        /**
         * @param date
         * @return {{from: number, to: number}|null}
         * @private
         */
        function getWorkingTimeBounds(date) {
            var dayOfWeek = date.getDay();
            if (dayOfWeek === 0) {
                // в вс не работаем
                return null;
            }

            var bounds = {
                from: DEFAULT_WORK_START_HOUR,
                to: DEFAULT_WORK_END_HOUR
            };

            if (dayOfWeek === 6) {
                // в сб до 3 можно подать заявку
                bounds.to = SATURDAY_WORK_END_HOUR;
            }

            return bounds;
        }

        module.exports = {
            isWorkingTimeNow: function isWorkingTimeNow() {
                var now = new Date();
                var currentHour = now.getHours();

                // var sundayDate = '2018-4-8';
                // var d = new Date(sundayDate);
                // d.setHours(8);

                if (window.app.debug) {
                    // return true;
                }

                var timeBounds = getWorkingTimeBounds(now);
                if (timeBounds === null) {
                    return false;
                }

                var isNotWorkingMorning = currentHour < timeBounds.from;
                var isNotWorkingEvening = currentHour >= timeBounds.to;

                return !(isNotWorkingMorning || isNotWorkingEvening);
            }
        };
    }, {}], 7: [function (require, module, exports) {
        // const PHONE_LENGTH = 10;
        function clearPhone(phone) {
            return ('' + phone).trim()
            // remove phone mask code
            .replace("+" + window.app.phoneConfig.prefix, '').replace(/\D/g, '');
        }

        module.exports = {
            /**
             * @param {string|number} rawPhone
             * @return {boolean}
             */
            validatePhone: function validatePhone(rawPhone) {
                var phoneLength = clearPhone(rawPhone).length;
                return window.app.phoneConfig.clearLengths.indexOf(phoneLength) !== -1;
            }
        };
    }, {}] }, {}, [1]);